export enum Flow {
  common = 'common',
  device = 'device',
}
